import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { compose } from 'recompose'

import { Table, Data } from 'components/layout/Table'
import { Button } from 'components/misc'
import { myOrganization as myOrganizationLayout } from 'constants/layout'
import { apiOrganizations, apiAwards } from 'helpers/decorators/api'

const enhance = compose(
  apiOrganizations({
    leaders: true,
    disableLimit: true,
    excludeInactive: true
  }),
  apiAwards({
    listReadParams: 'PAYMENT_INFO,LEADER,PARTICIPANT_REGISTRATION',
    updateParticipantDetail: true
  })
)

class LeaderSelector extends Component {
  static propTypes = {
    organizations: PropTypes.object.isRequired,
    awards: PropTypes.object.isRequired,
    refreshAward: PropTypes.func,
    setOrganizationContactsParams: PropTypes.func.isRequired,
    changeLeader: PropTypes.func.isRequired,
    modal: PropTypes.func.isRequired,
    awardId: PropTypes.number
  }

  state = {
    activeId: null
  }

  handleSelect = activeId => this.setState({ activeId })

  handleChangeLeader = async (awardId, activeId) => {
    const { changeLeader, refreshAward, modal } = this.props
    await changeLeader(awardId, activeId)
    await refreshAward()
    modal(null)
  }

  render() {
    const {
      organizations: { leaders: { loading, list, offset, limit, pages, sort } },
      setOrganizationContactsParams,
      awardId,
      awards
    } = this.props
    const { activeId } = this.state

    return (
      <div>
        <Table
          loading={loading}
          length={list.length}
          offset={offset}
          limit={limit}
          pages={pages}
          sort={sort}
          ths={myOrganizationLayout.tableHeaderContacts}
          setParams={setOrganizationContactsParams}
          selectable
        >
          <Data>
            {list.map(item => (
              <tr
                key={item.id}
                onClick={() => this.handleSelect(item.id)}
                className={activeId === item.id ? 'active' : ''}
              >
                <td>{item.id}</td>
                <td>{get(item, 'person.firstName')}</td>
                <td>{get(item, 'person.lastName')}</td>
                <td>{get(item, 'person.email')}</td>
              </tr>
            ))}
          </Data>
        </Table>
        <div className="base-margin--top">
          <div className="row">
            <div className="col-xs-6">
              <Button
                intlKey="button.cancel"
                secondary
                onClick={() => this.props.modal(null)}
              >
                Cancel
              </Button>
            </div>
            <div className="col-xs-6 text--right">
              <Button
                intlKey="button.change"
                disabled={!activeId}
                isLoading={awards.loading}
                onClick={() => this.handleChangeLeader(awardId, activeId)}
              >
                Change
              </Button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default enhance(LeaderSelector)
